<template>
  <el-checkbox
      v-bind="$attrs"
      v-on="$listeners">
    <slot></slot>
  </el-checkbox>
</template>

<script>
  export default {
    name: "gj-checkbox",
    props: {
      name: {
        type: String
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-checkbox__label {
    font-size: 12px;
  }
</style>
